export function getDate(data: string) {
  return new Date(data).toLocaleDateString();
}
